import _getClassName from "babel-plugin-react-css-modules/dist/browser/getClassName";
import React from 'react';
import { Flex, Layout } from 'antd';
var _styleModuleImportMap = {
  "./components/public/ras.css": {
    "headerText": "client-components-remoteAccessServices-components-public-___ras__headerText___zl-Cx",
    "displayMobile": "client-components-remoteAccessServices-components-public-___ras__displayMobile___dEJo9",
    "displayDesktop": "client-components-remoteAccessServices-components-public-___ras__displayDesktop___g6DvW"
  }
};
var Header = Layout.Header,
  Footer = Layout.Footer,
  Content = Layout.Content;
import LeftNav from '@totem/components/remoteAccessServices/components/public/LeftNav';
import backgroundImage from './components/public/building_background.png';
import PageHeader from './components/public/Header';
import image from './components/public/intellinet_ib.svg';
import PageFooter from './components/public/PageFooter';
import RequestPasswordReset from './components/public/RequestPasswordReset';
import './components/public/ras.css';
var layoutStyle = {
  height: '100vh'
};
var headerStyle = {
  textAlign: 'center',
  color: '#000000',
  height: 90,
  paddingInline: 50,
  lineHeight: '64px',
  backgroundColor: '#ffffff',
  borderBottomColor: '#CCCCCC',
  borderBottomStyle: 'solid'
};
var contentStyle = {
  textAlign: 'center',
  height: '100%',
  minHeight: 120,
  color: '#000000',
  backgroundColor: '#ffffff',
  paddingTop: '20px',
  paddingLeft: '16px',
  paddingRight: '16px'
};
var contentStyleDesktop = {
  textAlign: 'center',
  height: '100%',
  minHeight: 120,
  color: '#000000',
  backgroundImage: "url(".concat(backgroundImage, ")"),
  backgroundSize: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundColor: '#ffffff',
  paddingTop: '20px'
};
var footerStyle = {
  textAlign: 'center',
  color: '#000',
  backgroundColor: '#fff',
  borderTopColor: '#CCCCCC',
  borderTopStyle: 'solid'
};
var imageStyle = {
  maxWidth: '600px',
  width: '90%',
  marginTop: '24px',
  marginLeft: '24px',
  marginRight: '24px'
};
var entryBox = {
  backgroundColor: 'rgb(255, 255, 255, .65)',
  borderColor: '#CCCCCC',
  borderStyle: 'solid',
  borderWidth: '2px',
  padding: '24px'
};
function RemoteAccessServicesRoot() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: _getClassName('displayMobile', _styleModuleImportMap)
  }, /*#__PURE__*/React.createElement(Layout, {
    style: layoutStyle
  }, /*#__PURE__*/React.createElement(Header, {
    style: headerStyle
  }, /*#__PURE__*/React.createElement(PageHeader, null)), /*#__PURE__*/React.createElement(Content, {
    style: contentStyle
  }, /*#__PURE__*/React.createElement(RequestPasswordReset, null), /*#__PURE__*/React.createElement("img", {
    src: image,
    style: imageStyle
  })), /*#__PURE__*/React.createElement(Footer, {
    style: footerStyle
  }, /*#__PURE__*/React.createElement(PageFooter, null)))), /*#__PURE__*/React.createElement("div", {
    className: _getClassName('displayDesktop', _styleModuleImportMap)
  }, /*#__PURE__*/React.createElement(Layout, {
    style: layoutStyle
  }, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Header, {
    style: headerStyle
  }, /*#__PURE__*/React.createElement(Flex, {
    justify: 'space-between'
  }, /*#__PURE__*/React.createElement(LeftNav, null), /*#__PURE__*/React.createElement(PageHeader, null), /*#__PURE__*/React.createElement("div", null, "\xA0"))), /*#__PURE__*/React.createElement(Content, {
    style: contentStyleDesktop
  }, /*#__PURE__*/React.createElement(Flex, {
    justify: 'center',
    align: 'flex-start'
  }, /*#__PURE__*/React.createElement("div", {
    style: entryBox
  }, /*#__PURE__*/React.createElement(RequestPasswordReset, null)))), /*#__PURE__*/React.createElement(Footer, {
    style: footerStyle
  }, /*#__PURE__*/React.createElement(PageFooter, null))))));
}
export default RemoteAccessServicesRoot;